<template>
    <div class="animated fadeIn">
    <div id="overlay" >
          <div class="loader"></div>
          <br/>
         <span class="loading" style="color:#fff;">Loading...</span>
        </div>
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <b-row>
                <b-col md="6">
                  <strong>Daily Plan Master</strong>
                </b-col>
                <!-- <b-col md="3" class="text-right">
                  <b-button variant="info" size="sm" @click="downloadSampleExcelForDailyPlan()">Download Sample Excel</b-button>
                </b-col> -->
                <b-col md="6" class="text-right">
                  <b-button variant="info" size="sm" @click="addplanmaster()">Add Plan</b-button>
                </b-col>
              </b-row>
        
              <div class="card-header-actions"></div>
            </div>

           <b-col>
            <form @submit="searchfilter">
            <b-row class="mt-2 mb-2">
             
              <b-col md="5">
                  <b-form-group label="Warehouse ID" :label-cols="3">
                      <ejs-multiselect id='multi_select2'  placeholder="Select WareHouse" v-model="searchvalueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"  :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox"></ejs-multiselect>
                  </b-form-group>
              </b-col>
              <b-col md="5">
                  <b-form-group label="Planning Date From" :label-cols="3">
                    <v-date-picker mode='single' input-class="dateInput" v-model='searchselectDateFrom'>
                    </v-date-picker>
                    <!-- :available-dates='{ start: null, end: new Date() }' -->
                  </b-form-group>
                  <b-form-group label="Planning Date To" :label-cols="3">
                    <v-date-picker mode='single' input-class="dateInput" v-model='searchselectDateTo'  :available-dates='{ start: searchselectDateFrom}' >
                    </v-date-picker>
                  </b-form-group>
              </b-col>  
              <b-col md="2">
                <b-button variant="primary" type="submit">Search</b-button>&nbsp;
                <b-button variant="danger" @click="clearSearch()">Clear</b-button>
              </b-col>
              
            </b-row>
          </form>
           </b-col>
           <b-row>
            <b-col class="text-right" sm="12">
              <b-button class="btn btn-info" @click="downloadConsolidatedPlanDetailExcel">Download Consolidated Excel</b-button>
            </b-col>
            <b-col class="text-right" sm="12"><br/></b-col>
            <b-col class="text-right" sm="12">
             <h5>Total Records: <span style="color:red;">{{ totalPlanRows }}</span></h5>
            </b-col>
           </b-row>
            <hr />
        
            <b-col sm="12">
              <b-table 
              show-empty
              responsive  
              :items="plan_list"
              :fields="fields"  
              :bordered="bordered"
              :filter="vehiclefilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
              :per-page="perPlanPage"
              >
              <template slot="serial_no" slot-scope="row">
                {{ currentPlanPage*10 + plan_list.indexOf(row.item) + 1 -10 }}
              </template>
              <template slot="uploadeddate" slot-scope="row"> 
                {{
                    new Date(row.item.uploaded_date).getDate() +
                      "/" +
                      (new Date(row.item.uploaded_date).getMonth() + 1) +
                      "/" +
                      new Date(row.item.uploaded_date).getFullYear()
                  }}
              </template>
              <template slot="doanloafile" slot-scope="row">
                  <a  :href="row.item.file" download><i class="fa fa-download"></i></a>
              </template>
                <template slot="status" slot-scope="row">
                    <span
                      @click="toggleInfoModal(row.item)"
                      style="cursor:pointer;"
                    >
                      <span
                        data-toggle="tooltip"
                        title="InActive"
                        v-if="row.item.status === '0'"
                      >
                        <span class="badge badge-danger">Inative</span>
                      </span>
                      <span data-toggle="tooltip" title="Active" v-else>
                        <span class="badge badge-success">Active</span>
                      </span>
                    </span>
                </template>
                <template slot="action" slot-scope="row">
                    <b-button size="sm" @click="PlanViewdetails(row.item)" class="mr-2">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </b-button>
                    <b-button size="sm" @click="deletePlanDetail(row.item.id)">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </b-button>
                 </template>
              </b-table>
            </b-col>
            <b-col md="12" class="my-1">
              <paginate       
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="planPageChange"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>     

            <b-modal sixe="lg" title="Delete Plan Data" v-model="deletePlanDetailsModal" @ok="deletePlanDetailsModal=false" hide-footer>
              <div id="overlaymodel" >
                    <div class="modelloader"></div>
                    <br/>
              </div>
            <h5>Are you sure, Want to delete this plan?</h5>

            <b-col class="text-right">
              <br>
                <b-button size="md" class="mr-1" variant="primary" @click="deletePlanDetails(deleteplanId)">
                  Submit
                </b-button> 
                <b-button size="md" variant="danger" type="button" @click="canceldeletePlanDetailsModal">
                  Cancel
                </b-button> 
            </b-col>


            </b-modal>

            <b-modal size="xl" title="View Plan Details" v-model="plandetailsmodel" @ok="plandetailsmodel=false"
            hide-footer>
              <b-row>
                  <b-col sm="12" class="text-right">
                      <p > <b>Total Records :<span style="color:red;" >{{planDetails.length}}</span></b> </p>
                  </b-col>
              </b-row>
              
              <b-table
              show-empty responsive :busy="isBusy" :fields="planfields" :items="planDetails" :filter="filter" sort-by="unloading_sequence" sort-asc="true" :bordered="bordered"
                class="Delivery_Dashboard"
              >
                  <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                  </div>
              </b-table>
            </b-modal>

            <b-modal size="xl" title="Upload Daily Plan" v-model="addplanmasterdiv" @ok="addplanmasterdiv=false"
            hide-footer>
              <b-col>
                <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1" id="daily_plan_upload_form">
                  <b-row class="mt-2 mb-2">
                    <b-col md="6">
                    <div id="overlaymodel" >
                    <div class="modelloader"></div>
                    <br/>
                  <!-- <span class="loading" style="color:#fff;">Loading...</span> -->
                  </div>
                        <b-form-group label="Warehouse ID" :label-cols="3">
                             <b-form-select v-model="warehouseId" id="warehouseId" name="warehouseId"  v-validate="'required'" :class="{'input': true, 'is-invalid': errors.has('form-1.warehouseId') }" required>
                              <option :value="selected" >Select Option</option>
                              <!-- <option :value="warehouse_list.warehouseid" v-for="warehouse_list in warehouse_arr">{{ warehouse_list.warehousename}}</option> -->
                              <option :value="warehouse_list.name" v-for="warehouse_list in warehouse_arr">{{ warehouse_list.name}}</option>
                            </b-form-select> 
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Planning Date" :label-cols="3">
                          <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: planningDateEndLimit }' v-model='selectDateFrom' required>
                          </v-date-picker>
                          <!-- :available-dates='{ start: null, end: new Date() }' -->
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Choose File" :label-cols="3" class="">
                            <b-form-file col="2" type="file" v-model="file" :state="Boolean(file)" @change="selectcsvFiletoUpload($event)" placeholder="Upload CSV File" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" required></b-form-file>
                        </b-form-group>
                    </b-col>
                  </b-row>
                  <hr>
                  <b-row>
                    <b-col md="6" class="text-left">
                      <br/>
                      <b-button variant="secondary" size="sm" @click="downloadSampleExcelForDailyPlan()">Download Sample Excel</b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                      <br>
                        <b-button size="md" class="mr-1" variant="primary" type="submit">
                          Submit
                        </b-button> 
                        <b-button size="md" variant="danger" type="button" @click="canceladdplanmasterdiv">
                          Cancel
                        </b-button> 
                    </b-col>
                  </b-row>
                  <b-row id="isErrorExcel" style="display:none;">
                    <br/>
                    <div class="alert alert-danger">
                      <p>Invalid Excel Data! Please Download Following Excel File For Error Reference - <a href="" id="downloadErrorExcel" download="erroDailyPlanExcel.xlsx"><i class="fa fa-download" style="font-size:24px;"></i></a></p>
                    </div>
                  </b-row>
                </b-form>
              </b-col>
            </b-modal>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>

  <script>
    import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import auth from "@/utils/auth";
  export default {
    data() {
        return {
            currentPlanPage:1,
            perPlanPage: 10,
            totalPlanRows:0,
            noofpages:0,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            file :'',
            selectcsvFile :'',
            selectFiletype :'',
            selectDateFrom :new Date(),
            planningDateEndLimit: new Date(new Date().setDate(new Date().getDate() + 7)),
            
            fields: [
              { key: "serial_no", label: "Serial No"},
              { key: "warehouse_name", label: "Warehouse Name",sortable: true, sortDirection: "desc"},
              { key: "vehicle_number", label: "Vehicle Number",sortable: true, sortDirection: "desc"},             
               { key: "uploaded_by", label: "Uploaded By",sortable: true, sortDirection: "desc"},             
                { key: "uploadeddate", label: "Uploaded Date",sortable: true, sortDirection: "desc"},    
                { key: "planning_date", label: "Planning Date",sortable: true, sortDirection: "desc"},             
                //  { key: "status", label: "Status",sortable: true, sortDirection: "desc"},  
                { key: "total_load_count", label: "Total Load Count",sortable: true, sortDirection: "desc"},  
                { key: "total_box_count", label: "Total Box Count",sortable: true, sortDirection: "desc"},  
                 { key: "doanloafile", label: "Download File",sortable: true, sortDirection: "desc",},            
                  { key: "action", label: "Action",sortable: true, sortDirection: "desc",}, 
            ],
            plandetailsmodel : false,
            PlanDetails :[{Planning_origin:'Pune',Planning_date:'09/10/2023',loadid:'L27BW2324212ABC',WH_HUB:'WH',noofboxes:'34',shippingreferenceno:'RB150ABC',userid:'9ABC',companyname:'THE URBAN MALL',dest_city:'Thane',warehousename_Hubzone:'PNQ_Ext',loadpotype:'B2D',shipmentvolumetricweight:'471.08',shippincode:'421503',city:'BADLAPUR',unloading_sequence:'1',vehicle_number:'MH43SX4567'},
            {Planning_origin:'Pune',Planning_date:'09/10/2023',loadid:'L27BW2324212XYZ',WH_HUB:'HUB',noofboxes:'88',shippingreferenceno:'RB150XYZ',userid:'9XYZ',companyname:'DOON CAFE',dest_city:'Thane',warehousename_Hubzone:'Zone2',loadpotype:'B2F',shipmentvolumetricweight:'259.02',shippincode:'421508',city:'BADLAPUR',unloading_sequence:'2',vehicle_number:'MH43SX4567'}],
            planfields:[
              {key:'planning_origin', label:'Planning Origin', sortable: true, sortDirection: "desc"},
              {key:'planning_date', label:'Planning Date', sortable: true, sortDirection: "desc"},
              {key:'loadid', label:'Load ID', sortable: true, sortDirection: "desc"},
              {key:'hub_name', label:'WH / HUB', sortable: true, sortDirection: "desc"},
              {key:'noofboxes', label:'No Of Boxes', sortable: true, sortDirection: "desc"},
              {key:'shippingreferenceno', label:'Shipping Reference No', sortable: true, sortDirection: "desc"},
              {key:'userid', label:'User ID', sortable: true, sortDirection: "desc"},
              {key:'companyname', label:'Company Name', sortable: true, sortDirection: "desc"},
              {key:'dest_city', label:'Destination City', sortable: true, sortDirection: "desc"},
              {key:'hub_zone', label:'Warehouse Name / Hub Zone', sortable: true, sortDirection: "desc"},
              {key:'loadpotype', label:'Load Po Type', sortable: true, sortDirection: "desc"},
              {key:'shipmentvolumetricweight', label:'Shipment Volumetric Weight', sortable: true, sortDirection: "desc"},
              {key:'shippincode', label:'Shippin Code', sortable: true, sortDirection: "desc"},
              // {key:'city', label:'City', sortable: true, sortDirection: "desc"},
              {key:'unloading_sequence', label:'Unloading Sequence', sortable: true, sortDirection: "desc"},
              {key:'vehicle_number', label:'Vehicle Number', sortable: true, sortDirection: "desc"},
              {key:'transporter_name', label:'Transporter Name', sortable: true, sortDirection: "desc"},
              {key:'regular_or_adhoc', label:'Regular/Adhoc', sortable: true, sortDirection: "desc"},
            ],
            addplanmasterdiv :false,
            searchselectDateFrom : new Date(),
            searchselectDateTo : new Date(),
            searchvalueWH :[],
            mailId:"",
            warehouse_arr: [],
            warehouseId: "",
            plan_list: [],
            warehousid: '',
            planId: '',
            planDetails:[],
            searchdata: false,
            object:{},
            deletePlanDetailsModal: false,
            isBusy:false,
            // noofpages:'',
            // pageNum:1,

        }
    },
    watch: {
      searchselectDateFrom() {
        this.handleSearchSelectDateFrom()
      }
    },
    created() {
        var userdata = localStorage.getItem("userData");
       var userInfo = JSON.parse(userdata);
       this.mailId = userInfo.sysemailid
       console.log(this.mailId)
        this.showWHlist();
        this.getUploadedPlanList();
    },
    methods: {
        handleSearchSelectDateFrom(){
          this.searchselectDateTo = null
        },
        addplanmaster(){
          if ( this.addplanmasterdiv == true) {
            this.addplanmasterdiv = false;
          } else {
            this.addplanmasterdiv = true;
            this.warehouseListForModal();
          }
        },

        PlanViewdetails(value){
          this.planId = value.id;
          this.warehousid = value.warehouse_id
          this.getUploadedPlanListDetails();
          this.plandetailsmodel = true;
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
            if (result) {
                this.uploadPalnDetails();
            }
            });
        },

        selectcsvFiletoUpload(event) {
            this.selectcsvFile = event.target.files[0];
            // this.imgname= this.selectedFiles.name;
            console.log("HHH", this.selectcsvFile);
            this.selectFiletype = event.target.files[0].type;
            // console.log("selectFiletype", this.selectFiletype);
        },

        showWHlist:function(){
          // refer
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
            // console.log("JJJJJ",csvObj);
                // return false;

            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
            
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/fetchDailyPlanningCityList`, csvObj)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.optionsWH=[];
                
                    this.WHData  = result.body.returnvalue;
                    // console.log("HHHHHHH",this.WHData)
                    
                    for(let j = 0; j < this.WHData.length; j++) {
                        // let WH = {
                        // name: this.WHData[j].warehousename + " - " + this.WHData[j].warehouseid,
                        // id: this.WHData[j].warehouseid,
                        // }
                      let WH = {
                        name: this.WHData[j].name,
                        id: this.WHData[j].name,
                      }
                      this.optionsWH.push(WH);
                    }
                
                } else {              
                    this.WHData  = result.body.returnvalue;
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        clearSearch() {
          this.searchvalueWH = '';
          this.searchdata = false;
          this.getUploadedPlanList();
          this.currentPlanPage = 1
          this.searchselectDateFrom = new Date();
          this.searchselectDateTo = new Date();
        },


        getUploadedPlanList:function(page_num=1){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)

            if(this.searchdata == false)
            { 
               this.object = {
                  warehouse_id: '',
                  page_no: page_num,
                  planning_date_from : new Date(),
                  planning_date_to : new Date()
                };

            }else{
              if(this.searchselectDateFrom && this.searchselectDateTo){
                const fromDateString = this.searchselectDateFrom
                const fromDateOffset = new Date(fromDateString).getTimezoneOffset();
                const correctedFromDate = new Date(new Date(fromDateString).getTime() - fromDateOffset * 60 * 1000);
                const formattedFromDate = correctedFromDate.toISOString().slice(0, 10);

                const toDateString = this.searchselectDateTo
                const toDateOffset = new Date(toDateString).getTimezoneOffset();
                const correctedToDate = new Date(new Date(toDateString).getTime() - toDateOffset * 60 * 1000);
                const formattedToDate = correctedToDate.toISOString().slice(0, 10);

                this.object = {
                  warehouse_id: this.searchvalueWH,
                  page_no: page_num,
                  planning_date_from : formattedFromDate,
                  planning_date_to : formattedToDate
                };
              }else{
                let errorName
                if(!this.searchselectDateFrom) errorName = 'Please select From Date!'
                if(!this.searchselectDateTo) errorName = 'Please select To Date!'
                this.$fire({
                  text: errorName,
                  type: "error",
                  timer: 30000,
                });
                return
              }
            }
            
           
        
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getUploadedPlanList`, this.object)
                .then(result => {
                
                if (result.body.returnmsg === 'Successful') {
                    this.plan_list = result.body.returnvalue
                    this.totalPlanRows = result.body.totalCount
                    // this.totalRows = result.body.totalcount;  
                    //   console.log("HHHHH",this.totalRows); 
                    // this.noofpages=parseInt(this.totalRows)/60;
                    // console.log("this.noofpages",this.noofpages)
                    // this.noofpages=Math.ceil( this.noofpages);
                    // console.log("YYYYYY",this.noofpages)   
                    this.noofpages = parseInt(result.body.totalCount) / 10;
                    this.noofpages = Math.ceil(this.noofpages);
                
                } else {              
                    this.plan_list = []
                }
            

            })
            .catch(ex => {
                console.log("error-----", ex);
            });
        },

        planPageChange(page_num){
          this.currentPlanPage = page_num
          this.getUploadedPlanList(page_num)
        },

        canceladdplanmasterdiv(){
           this.selectcsvFile = ''
          this.warehouseId = ''
          this.selectDateFrom = new Date()
          // this.mailId = ''
            this.addplanmasterdiv = false ;
            document.getElementById('isErrorExcel').style.display = "none"

        },

        uploadPalnDetails()
        {
          document.getElementById("overlaymodel").style.display = "block";
          const dateString = this.selectDateFrom
          const offset = new Date(dateString).getTimezoneOffset();
          const correctedDate = new Date(new Date(dateString).getTime() - offset * 60 * 1000);
          const formattedDate = correctedDate.toISOString().slice(0, 10);

          let data = new FormData();
          data.append("file", this.selectcsvFile);
          data.append("planning_origin", this.warehouseId);
          data.append("planning_date", formattedDate);
          data.append("uploaded_by", this.mailId);
          // data.append("file", this.selectcsvFile);

          console.log('uploadPalnDetails data---------------->',data)
          console.log('uploadPalnDetails this.selectDateFrom---------------->',this.selectDateFrom)
          let config = {
            header: {
              "Content-Type": "multipart/form-data",
            },
          };

          // uploadDailyPlan
           this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/uploadDailyPlan`, data, config )
            .then(result => {
              // document.getElementById("overlaymodel").style.display = "none";
              if (result.body.returnmsg === 'Successful') {
               
                this.selectcsvFile = ''
                this.warehouseId = ''
                this.selectDateFrom = new Date()
                this.searchselectDateFrom = new Date()
                this.searchdata = false
                this.searchselectDateTo = new Date()
                // this.mailId = ''
                this.addplanmasterdiv = false;
                this.getUploadedPlanList();
                document.getElementById("overlaymodel").style.display = "none";
                document.getElementById('isErrorExcel').style.display = "none"
                this.$fire({
                  text: "Data Addedd Successfully",
                  type: "success",
                  timer: 30000,
                });

              }else{
                if(result && result.data && result.data.excelFile){
                  document.getElementById('isErrorExcel').style.display = "none"
                  this.isUploadErrorWithExcel = true
                  const base64String = result.data.excelFile
                  const binaryString = window.atob(base64String);
                  const uint8Array = new Uint8Array(binaryString.length);
                  for (let i = 0; i < binaryString.length; i++) {
                      uint8Array[i] = binaryString.charCodeAt(i);
                  }
                  const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  const url = window.URL.createObjectURL(blob);
                  // window.open(url, '_blank');
                  // const a = document.createElement('a');
                  // a.href = url;
                  // a.download = `error_${this.selectcsvFile.name.replace(/ /g,'_')}.xlsx`; // Set your custom file name here
                  // a.click();
                  // window.URL.revokeObjectURL(url);
                  // a.remove()

                  document.getElementById('downloadErrorExcel').href = url
                  document.getElementById('isErrorExcel').style.display = "block"
                  document.getElementById("overlaymodel").style.display = "none";
                  

                  this.$fire({
                    text: (result && result.body && result.body.returnvalue) ? result.body.returnvalue+'. '+'Please refer downloaded excel for errors!' : 'Please Close Modal And Try Again!',
                    type: "error",
                    timer: 30000,
                  });
                  
                }else{
                  document.getElementById('isErrorExcel').style.display = "none"
                  document.getElementById("overlaymodel").style.display = "none";
                  let text = (result && result.body && result.body.returnvalue) ?  result.body.returnvalue : 'Please Close Modal And Try Again!' 
                  this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000,
                  });
                }
              }


            })
            .catch(err=>{
              document.getElementById('isErrorExcel').style.display = "none"
              document.getElementById("overlaymodel").style.display = "none";
              this.$fire({
                text: err.message ? err.message : 'Please Close Modal And Try Again!',
                type: "error",
                timer: 30000,
              });
            })

         
        },
        downloadSampleExcelForDailyPlan:function(){
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadSampleExcelForDailyPlan`, {})
          .then(result => {
            console.log(result)
            if (result.status === 200) {
              const base64String = result.data
              const binaryString = window.atob(base64String);
              const uint8Array = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                  uint8Array[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              // window.open(url, '_blank');
              const a = document.createElement('a');
              a.href = url;
              a.download = 'daily_plan_upload_sample.xlsx'; // Set your custom file name here
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove()
            } else{
              throw new Error('Invalid File Result!')
            }
          })
          .catch(ex => {
              console.log("error-----", ex);
              this.$fire({
                text: 'Error in downloading sample excel file!',
                type: "error",
                timer: 30000,
              });
          });
        },

        downloadConsolidatedPlanDetailExcel(){
          var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            let object;

            if(this.searchdata == false)
            { 
               object = {
                  warehouse_id: '',
                  page_no: 1,
                  planning_date_from : new Date(),
                  planning_date_to : new Date()
                };

            }else{
              const fromDateString = this.searchselectDateFrom
              const fromDateOffset = new Date(fromDateString).getTimezoneOffset();
              const correctedFromDate = new Date(new Date(fromDateString).getTime() - fromDateOffset * 60 * 1000);
              const formattedFromDate = correctedFromDate.toISOString().slice(0, 10);

              const toDateString = this.searchselectDateTo
              const toDateOffset = new Date(toDateString).getTimezoneOffset();
              const correctedToDate = new Date(new Date(toDateString).getTime() - toDateOffset * 60 * 1000);
              const formattedToDate = correctedToDate.toISOString().slice(0, 10);

                object = {
                  warehouse_id: this.searchvalueWH,
                  page_no: 1,
                  planning_date_from : formattedFromDate,
                  planning_date_to : formattedToDate
                };

            }
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/downloadConsolidatedPlanDetailExcel`, object)
          .then(result => {
            console.log('downloadConsolidatedPlanDetailExcel result--------->',result)
            if (result.status === 200 && result.body && !result.body.returnmsg) {
              const base64String = result.data
              const binaryString = window.atob(base64String);
              const uint8Array = new Uint8Array(binaryString.length);
              for (let i = 0; i < binaryString.length; i++) {
                  uint8Array[i] = binaryString.charCodeAt(i);
              }
              const blob = new Blob([uint8Array], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              // window.open(url, '_blank');
              const a = document.createElement('a');
              a.href = url;
              a.download = this.searchvalueWH.length>0 ? `${this.searchvalueWH.join('_')}-${Date.now()}.xlsx` : `${Date.now()}.xlsx`;
              a.click();
              window.URL.revokeObjectURL(url);
              a.remove()
            } else{
              if(result.body && result.body.returnmsg && result.body.returnmsg=='Unsuccessful' && result.body.returnvalue=='No Records Found'){
                this.$fire({
                  text: 'No Records Found!',
                  type: "error",
                  timer: 30000,
                });
              }else{
                throw new Error('Invalid File Result!')
              }
            }
          })
          .catch(error=>{
            console.log('downloadConsolidatedPlanDetailExcel error--------->',error)
            this.$fire({
              text: 'Error in downloading plan data excel file!',
              type: "error",
              timer: 30000,
            });
          })
        },

      warehouseListForModal:function(){
          
            var userdata = localStorage.getItem('userData')
            var userInfo = JSON.parse(userdata)
            
            var csvObj = {};
            // console.log("JJJJJ",csvObj);
                // return false;

            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getWarehouselisting`, csvObj)
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/fetchDailyPlanningCityList`, csvObj)
            .then(result => {
              if (result.body.returnmsg === 'Successful') {
                this.warehouse_arr = result.body.returnvalue
                console.log("this.warehouse_arr",this.warehouse_arr)
              } 
            })
            .catch(ex => {
              console.log("error-----", ex);
            });
        },


        getUploadedPlanListDetails()
        {
           this.isBusy=true
          const Obj = {
            plan_id : this.planId.toString(),
            warehouse_id: this.warehousid,
            page_no: ""
          }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getUploadedPlanListDetails`, Obj)
            .then(result => {
              this.isBusy=false;
              if(result.body.returnmsg == 'Successful'){
                this.planDetails = result.body.returnvalue
                console.log("this.planDetails",this.planDetails)
              }
              else{
                 this.planDetails = []
              }
            })          
        },

        searchfilter(e)
        {
          e.preventDefault();
          this.currentPlanPage = 1
          this.searchdata = true;
          this.getUploadedPlanList()
        },

        deletePlanDetails(id){
           document.getElementById("overlaymodel").style.display = "block";
          const obj ={
            plan_id : id
          }

          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/deleteDailyPlan`, obj)
            .then(result => {
               document.getElementById("overlaymodel").style.display = "none";
              if(result.body.returnmsg == 'Successful'){
                 this.$fire({
                  text: "Record Deleted",
                  type: "Success",
                  timer: 30000,
                  
                });
                this.deletePlanDetailsModal = false;
                this.getUploadedPlanList()
              }else{
                 this.$fire({
                  text: result.body.returnvalue,
                  type: "error",
                  timer: 30000,
                });
              }
            })
        },

        deletePlanDetail(id)
        {
          // alert()
          this.deleteplanId= id
          this.deletePlanDetailsModal = true;
        },

        canceldeletePlanDetailsModal()
        {
           this.deletePlanDetailsModal = false;
        }

    },
  }
  </script>

  <style>

#overlaymodel {
  position: fixed; /* Sit on top of the page content */
  display: none; /* Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
  .modelloader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left:50%;
  top:50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

  </style>